<script>
    import clsx from "clsx";
</script>

<div
    class={clsx(
        "flex w-full flex-shrink-0 flex-col items-center justify-center",
        $$props.class,
    )}
>
    <slot />
</div>
